import React from 'react';
import { TopBar } from '../components/layout/TopBar';
import { Header } from '../components/layout/Header';
import { Navigation } from '../components/layout/Navigation';
import { MobileStickyBar } from '../components/layout/MobileStickyBar';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/home/Hero';
import { TrustRail } from '../components/home/TrustRail';
import { DecisionCards } from '../components/home/DecisionCards';
import { PopularPaths } from '../components/home/PopularPaths';
import { GuidedBuyer } from '../components/home/GuidedBuyer';
import { CommercialStrip } from '../components/home/CommercialStrip';
import { InstallationService } from '../components/home/InstallationService';
import { Checklist } from '../components/home/Checklist';
import { ReviewsTrust } from '../components/home/ReviewsTrust';
export function Home() {
  return <div className="min-h-screen flex flex-col" data-id="element-787">
      <TopBar data-id="element-788" />
      <Header data-id="element-789" />
      <Navigation data-id="element-790" />

      <main className="flex-grow" data-id="element-791">
        <Hero data-id="element-792" />
        <TrustRail data-id="element-793" />
        <DecisionCards data-id="element-794" />
        <PopularPaths data-id="element-795" />
        <GuidedBuyer data-id="element-796" />
        <CommercialStrip data-id="element-797" />
        <InstallationService data-id="element-798" />
        <Checklist data-id="element-799" />
        <ReviewsTrust data-id="element-800" />
      </main>

      <Footer data-id="element-801" />
      <MobileStickyBar data-id="element-802" />
    </div>;
}